import { useQuery } from '@tanstack/react-query';
import {
  getHistory,
  getForecast,
  getSeasonal,
  getStock,
  getWarehouses,
  getCategories,
  getDashboard,
  getMultiplicity,
} from './analyticsApi';

export const useDashboard = () => {
  // Перевіряємо чи розрахунки зроблені
  const forecastsCalculated = localStorage.getItem('forecastsCalculated') === 'true';
  
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: getDashboard,
    enabled: forecastsCalculated, // Завантажувати тільки якщо розрахунки зроблені
  });
};

export const useHistory = () => useQuery({
  queryKey: ['history'],
  queryFn: getHistory,
});

export const useForecast = () => useQuery({
  queryKey: ['forecast'],
  queryFn: getForecast,
});

export const useSeasonal = () => useQuery({
  queryKey: ['seasonal'],
  queryFn: getSeasonal,
});

export const useStock = () => useQuery({
  queryKey: ['stock'],
  queryFn: getStock,
  staleTime: 0,              // Завжди вважати дані застарілими
  cacheTime: 60000,          // Зберігати в кеші 1 хвилину
  refetchOnMount: true,      // Завжди перезавантажувати при mount
  refetchOnWindowFocus: true // Оновлювати при поверненні на вкладку
});

export const useWarehouses = () => useQuery({
  queryKey: ['warehouses'],
  queryFn: getWarehouses,
});

export const useCategories = () => useQuery({
  queryKey: ['categories'],
  queryFn: getCategories,
});

export const useMultiplicity = () => useQuery({
  queryKey: ['multiplicity'],
  queryFn: getMultiplicity,
  staleTime: 5 * 60 * 1000, // 5 хвилин кеш
});
